import React, { useEffect, useRef, useState } from 'react';
import { Input } from 'antd';
import { useSearchParams } from 'react-router-dom';

const { Search } = Input;

const SearchInput = ({
  value = '',
  placeholder = 'Search',
  delay = 400,
  onSearchChange, 
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState(value);
  const debounceRef = useRef(null);


  // useEffect(() => {
  //   const urlSearch = searchParams.get('search') || '';
  //   setInputValue(urlSearch);
  //   onSearchChange?.(urlSearch);
   
  // }, []);

  const handleChange = (e) => {
    const val = e.target.value;

    setInputValue(val);
 
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (val) {
        setSearchParams({ search: val });
      } else {
        setSearchParams({});
      }

  
      onSearchChange?.(val);
    }, delay);
  };

  return (
    <Search
      allowClear
      placeholder={placeholder}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

export default SearchInput;